"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDiceEvent = void 0;
var EDiceEvent;
(function (EDiceEvent) {
    EDiceEvent[EDiceEvent["NO_ACTION_REQUIRED"] = 0] = "NO_ACTION_REQUIRED";
    EDiceEvent[EDiceEvent["MUST_ROLL_DICE"] = 1] = "MUST_ROLL_DICE";
    EDiceEvent[EDiceEvent["DICE_ROLLED"] = 2] = "DICE_ROLLED";
})(EDiceEvent || (EDiceEvent = {}));
exports.EDiceEvent = EDiceEvent;
